export default __webpack_public_path__ + "static/media/boy2.d2bee547.svg";